export default {
  REFRESH_DROP_TEXT: '下拉刷新',
  REFRESH_ENTER_TEXT: '释放刷新',
  REFRESH_LOADING_TEXT: '正在刷新...',
  REFRESH_FINISHED_TEXT: '刷新成功',
  NO_DATA_TEXT: '我是有底线的',
  LOADING_TEXT: '正在加载...',
};
